/**
 * ============================================================================
 * USER / TENANT SERVICE: Wallet & Ledgers (Sheets 17 & 18 + Master Credit System)
 * ============================================================================
 * Purpose:
 *   Tracks tenant credit additions (`tbl_credit_ledger`), broadcast usage
 *   deductions (`tbl_debit_ledger`), real-time wallet balances, and
 *   Administration multi-role credit operations (Add, Transfer, Remove).
 * ============================================================================
 */

import api from "../../core/services/api";
import { createCrudService } from "../../core/services/crudServiceFactory";

const creditService = createCrudService("tenant/ledgers/credit");
const debitService = createCrudService("tenant/ledgers/debit");

const ledgerService = {
  // Tenant Database Scoped Services
  credits: creditService,
  debits: debitService,

  /**
   * Retrieves real-time calculated wallet balance (Total Credits - Total Debits).
   * @returns {Promise<Object>} { totalCredits, totalDebits, currentBalance }
   */
  getBalance: () => {
    return api.get("/tenant/ledgers/balance");
  },

  // Master Administration Wallet Credit System
  /**
   * Retrieves role-scoped users and balances
   */
  getUsersAndBalances: (params = {}) => {
    return api.get("/wallet-credits/users", { params });
  },

  /**
   * SuperAdmin direct credit top-up
   */
  addCredit: (payload) => {
    return api.post("/wallet-credits/add", payload);
  },

  /**
   * Multi-role balance transfer (SuperAdmin, Admin, Reseller, Account)
   */
  transferCredit: (payload) => {
    return api.post("/wallet-credits/transfer", payload);
  },

  /**
   * Multi-role balance deduction (SuperAdmin, Admin, Reseller)
   */
  removeCredit: (payload) => {
    return api.post("/wallet-credits/remove", payload);
  },

  /**
   * Global transaction history audit log (Account, SuperAdmin, Admin, Reseller)
   */
  getTransactions: (params = {}) => {
    return api.get("/wallet-credits/transactions", { params });
  },
};

export default ledgerService;
